import type { TenantSettings } from '@/userManagement/domain/entities/TenantSettings';

function readSnapshotRetentionDays(raw: Record<string, unknown>): number | null {
  if (!('snapshotRetentionDays' in raw) && !('SnapshotRetentionDays' in raw)) {
    return null;
  }

  const value = 'snapshotRetentionDays' in raw ? raw.snapshotRetentionDays : raw.SnapshotRetentionDays;
  if (value == null || value === '') {
    return null;
  }

  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

/** Normalizes GET/PUT `/settings` wire payloads (camelCase or PascalCase). */
export function normalizeTenantSettings(raw: Record<string, unknown>): TenantSettings {
  return {
    approvalWorkflowEnabled: Boolean(raw.approvalWorkflowEnabled ?? raw.ApprovalWorkflowEnabled ?? false),
    erpWriteDisabled: Boolean(raw.erpWriteDisabled ?? raw.ErpWriteDisabled ?? false),
    snapshotRetentionDays: readSnapshotRetentionDays(raw),
    delegationMaxDays: Number(raw.delegationMaxDays ?? raw.DelegationMaxDays ?? 7),
    skipItAssignStep: Boolean(raw.skipItAssignStep ?? raw.SkipItAssignStep ?? false),
    requireReviewerForSensitiveChanges: Boolean(raw.requireReviewerForSensitiveChanges ?? raw.RequireReviewerForSensitiveChanges ?? true),
    ownerAdminSkipsReviewer: Boolean(raw.ownerAdminSkipsReviewer ?? raw.OwnerAdminSkipsReviewer ?? true),
    allowSelfApproval: Boolean(raw.allowSelfApproval ?? raw.AllowSelfApproval ?? false),
    builtInSystemAdminReadOnly: Boolean(raw.builtInSystemAdminReadOnly ?? raw.BuiltInSystemAdminReadOnly ?? false),
    // Default ON when absent (matches BE platform default / non-Brundage orgs).
    importErpAccessTemplates: Boolean(raw.importErpAccessTemplates ?? raw.ImportErpAccessTemplates ?? true)
  };
}
